import findLastIndex from 'lodash/findLastIndex';

export const SET_SHOW_SYSTEM_EVENTS = 'allEvents/SET_SHOW_SYSTEM_EVENTS';

export function setShowSystemEvents(isShown) {
  return {
    type: SET_SHOW_SYSTEM_EVENTS,
    payload: isShown,
  };
}

export const SET_DATE_RANGE = 'allEvents/SET_DATE_RANGE';

export function setDateRange({ preset, from, to }) {
  return {
    type: SET_DATE_RANGE,
    payload: { preset, from, to },
  };
}

export const SET_SORT = 'allEvents/SET_SORT';

export function setSort({ sortBy, sortOrder }) {
  return {
    type: SET_SORT,
    payload: { sortBy, sortOrder },
  };
}

export const SET_SEARCH = 'allEvents/SET_SEARCH';

export function setSearch(payload) {
  return {
    type: SET_SEARCH,
    payload,
  };
}

export const SET_COLUMN_STATE = 'allEvents/SET_COLUMN_STATE';

export function setColumnState(payload) {
  return {
    type: SET_COLUMN_STATE,
    payload,
  };
}

export const TOGGLE_COLUMN_VISIBILITY = 'allEvents/TOGGLE_COLUMN_VISIBILITY';

export function toggleColumnVisibility(payload) {
  return {
    type: TOGGLE_COLUMN_VISIBILITY,
    payload,
  };
}

export const REDIRECT_AUTOMATICALLY_TO_ALL_EVENTS =
  'allEvents/REDIRECT_AUTOMATICALLY_TO_ALL_EVENTS';

export function setRedirectAutomaticallyToAllEvents(payload) {
  return {
    type: REDIRECT_AUTOMATICALLY_TO_ALL_EVENTS,
    payload,
  };
}

export const EVENT_SELECTION = 'allEvents/EVENT_SELECTION';

export function eventSelection({ eventId, isSelected, shiftKey = false }) {
  return (dispatch, getState) => {
    if (isSelected && shiftKey) {
      const selectedEventIds = Object.entries(
        getState().allEvents?.selectedEvents ?? {},
      )
        .filter(([, val]) => val === true)
        .map(([key]) => key);

      const eventIds =
        getState().events?.result.map(
          uuid => getState().events.entities.events[uuid].eventId,
        ) ?? [];

      const lastSelectedEventIndex = findLastIndex(eventIds, evtId =>
        selectedEventIds.includes(evtId),
      );

      const currentlySelectedEventIndex = eventIds.indexOf(eventId);
      const first = Math.min(
        lastSelectedEventIndex,
        currentlySelectedEventIndex,
      );
      const last = Math.max(
        lastSelectedEventIndex,
        currentlySelectedEventIndex,
      );

      const eventIdsToSelect = getState()
        .events.result.slice(first + 1, last)
        .map(uuid => getState().events.entities.events[uuid].eventId);

      eventIdsToSelect.forEach(evtId =>
        dispatch(eventSelection({ eventId: evtId, isSelected: true })),
      );
    }

    dispatch({
      type: EVENT_SELECTION,
      payload: {
        eventId,
        isSelected,
      },
    });
  };
}

export const UNSELECT_ALL = 'allEvents/UNSELECT_ALL';

export function unselectAll() {
  return {
    type: UNSELECT_ALL,
  };
}

export const SELECT_ALL = 'allEvents/SELECT_ALL';

export function selectAll() {
  return {
    type: SELECT_ALL,
  };
}
